(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('personalEmail', personalEmail);

    function personalEmail() {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };
        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.personalEmail = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || validPersonalEmail(modelValue);
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function validPersonalEmail(email) {
            return !endsWith("@uniroma1.it", email.toLowerCase());
        }
    }
})();
